/**
 * @generated SignedSource<<3ab31c8573e6cd20d5b70844e23e85d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useCustomSelect_account$data = {
  readonly custom_select_types: ReadonlyArray<{
    readonly custom_select_options: ReadonlyArray<{
      readonly id: number;
      readonly name: string;
    }>;
    readonly id: number;
    readonly model: any;
    readonly name: string;
  }>;
  readonly " $fragmentType": "useCustomSelect_account";
};
export type useCustomSelect_account$key = {
  readonly " $data"?: useCustomSelect_account$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCustomSelect_account">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useCustomSelect_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "custom_select_types",
      "kind": "LinkedField",
      "name": "custom_select_types",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "model",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "custom_select_options",
          "kind": "LinkedField",
          "name": "custom_select_options",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "accounts",
  "abstractKey": null
};
})();

(node as any).hash = "6a377c4352934a9a26c281876ed9c27f";

export default node;
